import { computed } from 'vue';
import { required } from '@vuelidate/validators';

import type { Brand, BrandsApiResponse } from '@@/types/Brands';

export function mapApiToBrand(data: BrandsApiResponse): Brand {
  const brandSettings = data.settings;
  return {
    clientId: data.client_id,
    created_at: data.created_at,
    id: parseInt(data.id),
    domain: data.domain,
    sub_domain: data.sub_domain,
    updated_at: data.updated_at,
    settings: {
      schoolName: brandSettings.school_name,
      schoolTagLine: brandSettings.school_tag_line,
      hideSchoolName: brandSettings.hide_school_name,
      textColor: brandSettings.text_color,
      font: brandSettings.font,
      logoDark: brandSettings.logo_dark,
      logoLight: brandSettings.logo_light,
      favicon: brandSettings.favicon,
      colors: {
        primaryColor: brandSettings.colors?.primary_color.hex || '',
        linkColor: brandSettings.colors?.links_color.hex || '',
      },
    },
  };
}

export function mapBrandToApi(brand: Brand): unknown {
  return {
    domain: brand.domain,
    sub_domain: brand.sub_domain,
    settings: {
      school_name: brand.settings.schoolName,
      school_tag_line: brand.settings.schoolTagLine,
      hide_school_name: brand.settings.hideSchoolName,
      favicon: brand.settings.favicon,
      font: brand.settings.font,
      text_color: brand.settings.textColor,
      colors: {
        primary_color: { hex: brand.settings.colors.primaryColor },
        links_color: { hex: brand.settings.colors.linkColor },
      },
      logo_dark: brand.settings.logoDark,
      logo_light: brand.settings.logoLight,
    },
  };
}

export const brandValidationRules = computed(() => {
  return {
    settings: {
      schoolName: { required },
      colors: {
        primaryColor: { required },
        linkColor: { required },
      },
    },
  };
});
